import { usePageContext } from '#app/hooks/usePageContext.js';

export const useCurrentRouteKey = () => {
  const pageContext = usePageContext();

  const pageId = pageContext.pageId;

  if (!pageId) {
    throw new Error('Route key is undefined.');
  }

  return pageId;
};
